import React from 'react';

import Term from '../Term';

class Terms extends React.Component{
//
//  constructor(props){
//    super(props);
//
////    this.props.terms.map(obj => {
////      obj.Term = React.createRef();
////    })
//
//  }
//
//  componentDidMount() {
//    const element = document.findElementByAttribute('term',this.props.selectedTerm);
//
//    element.scrollIntoView({behavior: 'smooth'});
//  }


  render() {
    return(
      <ul>
        {
          this.props.terms.map((obj, index) => {
            return (
              <Term term={obj.Term}  key={index} selectedTerm={this.props.selectedTerm}/>
            )
          })
        }
      </ul>
    )
  }
}
export default Terms;



// WEBPACK FOOTER //
// ./src/components/Terms/terms.js